import { get } from 'lodash';

export const getUserId = (state) => {
    return get(state?.login?.userInfo, 'userId', null);
};
